/**
 * SubTabs — shared pill-less underline tabs used inside each Accounts
 * section (Overview / Cash / Investments / Liabilities) and inside every
 * account-detail page. Mirrors the Figma reference.
 */
import React from 'react';

export default function SubTabs({ tabs, active, onChange, testidPrefix = 'subtab' }) {
  return (
    <div className="flex items-center gap-0 border-b border-border/60 mb-6 overflow-x-auto" role="tablist">
      {tabs.map((t) => {
        const isActive = active === t.id;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            className={
              'flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium transition-colors relative whitespace-nowrap ' +
              (isActive
                ? 'text-evergreen'
                : 'text-muted-foreground hover:text-foreground')
            }
            role="tab"
            aria-selected={isActive}
            data-testid={`${testidPrefix}-${t.id}`}
          >
            {t.label}
            {t.count !== undefined && (
              <span
                className={
                  'text-[10px] font-medium px-1.5 py-0.5 rounded-full ' +
                  (isActive
                    ? 'bg-evergreen/10 text-evergreen'
                    : 'bg-muted text-muted-foreground')
                }
              >
                {t.count}
              </span>
            )}
            {isActive && (
              <span className="absolute bottom-0 left-0 right-0 h-[2px] bg-evergreen rounded-t-sm" />
            )}
          </button>
        );
      })}
    </div>
  );
}
